import React from 'react'
import { Button, FormControlLabel, Grid, IconButton, Switch, TextField, Tooltip, Typography } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import { useHistory } from 'react-router-dom'

// components
import PageTitle from '../../PageTitle/PageTitle'
// data
import { FormLoader } from '../../../Loader/FormLoader'
import { FormattedMessage, useIntl } from 'react-intl'
import Configuration from '../../../../Services/Api/Configuration'
import SubscriptionServices from '../../../../Services/Consumers/SubscriptionServices'
import { filterData } from '../../../../utils/helpers'
import { exportFiltersPayload, UsersFiltersPayload } from '../../../../Services/Payloads/AuthenticatedUserPayload'
import { useKeycloak } from '@react-keycloak/web'
import UserActionsMenu from './UserActionsMenu'
import { NamedRoutes } from '../../../../routes'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import { useStyles } from './Styles'

let { User_Config } = Configuration
export default function UsersContent ({ handleNotificationCall }) {
  let classes = useStyles()
  const intl = useIntl()
  const history = useHistory()
  const { keycloak } = useKeycloak()
  const [count, setCount] = React.useState(0)
  const [currentFilter, setCurrentFilter] = React.useState(null)
  const rowsPerPage = User_Config.usersListLimit
  const [sortOrder, setSortOrder] = React.useState({})
  const [data, setData] = React.useState(['Loading Data...'])
  const [loadedData, setLoadedData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [canCreate, setCanCreate] = React.useState(false)
  let EmailRegex = /^[\w-+.]+@([\w-]+\.)+[\w-]{2,4}$/
  let isFilterValid = {
    username: true,
    email: true
  }

  const columns = [
    {
      name: 'id',
      label: intl.formatMessage({ id: 'Users.List.Table.ID' }),
      options: {
        filter: false,
        display: 'false',
        viewColumns: false
      }
    },
    {
      name: 'username',
      label: intl.formatMessage({ id: 'Users.List.Table.UserName' }),
      options: {
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Users.List.Table.UserName'/>:
                <span>{v}</span>
              </div>
            )
          }
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <TextField
              fullWidth
              label={intl.formatMessage({ id: 'Users.List.Table.UserName' })}
              id='username'
              name='username'
              value={filterList[index][0] || ''}
              onChange={(event) => {
                filterList[index][0] = event.target.value
                onChange(filterList[index], index, column)
                isFilterValid.username = !(event.target.value && event.target.value.length > 12)
              }}
              helperText={(filterList[index][0] && (filterList[index][0]).length > 12) && intl.formatMessage({ id: 'validationSchema.userNameLengthMax' })}
              error={(filterList[index][0] && (filterList[index][0]).length > 12)}
            />
          )
        }
      }
    },
    {
      name: 'first_name',
      label: intl.formatMessage({ id: 'Users.List.Table.FirstName' }),
      options: {
        filter: false
      }
    },
    {
      name: 'last_name',
      label: intl.formatMessage({ id: 'Users.List.Table.LastName' }),
      options: {
        filter: false
      }
    },
    {
      name: 'email',
      label: intl.formatMessage({ id: 'Users.List.Table.Email' }),
      options: {
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Users.List.Table.Email'/>:
                <span>{v}</span>
              </div>
            )
          }
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <TextField
              fullWidth
              label={intl.formatMessage({ id: 'Users.List.Table.Email' })}
              id='email'
              name='email'
              value={filterList[index][0] || ''}
              onChange={(event) => {
                filterList[index][0] = event.target.value
                onChange(filterList[index], index, column)
                isFilterValid.email = !(event.target.value && !EmailRegex.test(event.target.value))
              }}
              helperText={(filterList[index][0] && !EmailRegex.test(filterList[index][0])) && intl.formatMessage({ id: 'validationSchema.validEmail' })}
              error={(filterList[index][0] && !EmailRegex.test(filterList[index][0]))}
            />
          )
        }
      }
    },
    {
      name: 'roles',
      label: intl.formatMessage({ id: 'Sidebar.Links.RolesAndPermissions' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return !!data[dataIndex].roles && !!data[dataIndex].roles.length &&
            <ul className={classes.RolesList}>
              {data[dataIndex].roles.map((role) => (
                <li key={role.id}>{role.name}</li>
              ))}
            </ul>
        }
      }
    },
    {
      name: 'active',
      label: intl.formatMessage({ id: 'Users.List.Table.Active' }),
      options: {
        filterOptions: {
          names: [0, 1],
          renderValue: v => !!v ? intl.formatMessage({ id: 'Users.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Users.List.Table.Active.Option.NotActive' })
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Users.List.Table.Active'/>:
                <span>{!!v ? intl.formatMessage({ id: 'Users.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Users.List.Table.Active.Option.NotActive' })}</span>
              </div>
            )
          }
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            !!tableMeta && tableMeta.rowData[0] &&
            <FormControlLabel
              label={value ? intl.formatMessage({ id: 'Users.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Users.List.Table.Active.Option.NotActive' })}
              value={value ? true : false}
              control={
                <Switch color="primary" checked={value} value={value ? true : false}/>
              }
              onChange={(event) => {
                updateValue(!JSON.parse(event.target.value))
                activateDeactivateUser(tableMeta.rowData[0], !JSON.parse(event.target.value), updateValue)
              }}
            />
          )
        }
      }
    },
    {
      name: '',
      options: {
        filter: false,
        print: false,
        viewColumns: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          return (<UserActionsMenu id={data[dataIndex].id} handleNotificationCall={handleNotificationCall}/>)
        }
      }
    }
  ]
  const updateLoadedData = (userId, newActiveValue) => {
    let newData = loadedData
    newData.forEach((pageData) => {
      pageData.forEach((user) => {
        if (userId === user.id) {
          user.active = !!newActiveValue ? 1 : 0
        }
      })
    })
    setLoadedData(newData)
  }
  const activateDeactivateUser = (userId, newActiveValue, updateValue) => {
    if (!!keycloak?.authenticated) {
      SubscriptionServices.activateDeactivateUser(userId, { 'active': newActiveValue }, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
      }, setIsLoading).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          handleNotificationCall({
            type: 'defence',
            message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
            color: 'error'
          }, 'error')
          updateValue(!newActiveValue)
        } else {
          if (!!result && !!result.data && !!result.data.data) {

            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({ id: newActiveValue ? 'Users.List.Table.Activate.Success' : 'Users.List.Table.Deactivate.Success' }),
              color: 'success'
            }, 'success')
            updateLoadedData(userId, newActiveValue)
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
            updateValue(!newActiveValue)
          }
        }

      })

    }
  }

// get data
  const getUsersListData = async (page) => {
    await xhrRequest(page)
  }
  // mock async function
  const xhrRequest = (page, sortOrder = {}, clear) => {
    if (!!keycloak?.authenticated) {

      setIsLoading(true)
      if (!!loadedData[page] && !!loadedData[page].length && !clear) {
        setData(loadedData[page])
        setIsLoading(false)
      } else {
        SubscriptionServices.getUsers({
          headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
          params: filterData(UsersFiltersPayload(page, rowsPerPage, currentFilter))
        }).then((result) => {
          if ((!!result.response && result.response.status !== 200) || !result) {
            let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
            if (result.response.data && result.response.data.status) {
              if (result.response.status === 403) {
                setData([])
                message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
              } else if (result.response.data.status.errors && result.response.status === 422) {
                message = result.response.data.status.errors
              } else if (result.response.data.status.message) {
                message = result.response.data.status.message
              }
            }
            handleNotificationCall({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
          } else {
            setCanCreate(true)
            if (!!result && !!result.data && !!result.data.data) {
              let newData = []
              result.data.data.forEach((user) => {
                if (user['country']) {
                  user['country'] = user['country'].name
                }
                if (user['government']) {
                  user['government'] = user['government'].name
                }
                if (user['city']) {
                  user['city'] = user['city'].name
                }
                newData.push(user)
              })
              setSortOrder(sortOrder)
              let sortField = sortOrder.name
              let sortDir = sortOrder.direction

              if (sortField) {
                newData = newData.sort((a, b) => {
                  if (a[sortField] < b[sortField]) {
                    return 1 * (sortDir === 'asc' ? -1 : 1)
                  } else if (a[sortField] > b[sortField]) {
                    return -1 * (sortDir === 'asc' ? -1 : 1)
                  } else {
                    return 0
                  }
                })
              }
              setData(newData)
              let prevData = loadedData
              prevData[page] = newData
              setLoadedData(prevData)
              setCount(result.data.meta.total)
            }
          }
        }).then(() => {
          setIsLoading(false)
        })
      }
    }
  }
  const sort = (page, sortOrder) => {
    setSortOrder(sortOrder)
    let sortField = sortOrder.name
    let sortDir = sortOrder.direction
    let newData = data

    if (sortField) {
      newData = newData.sort((a, b) => {
        if (a[sortField] < b[sortField]) {
          return 1 * (sortDir === 'asc' ? -1 : 1)
        } else if (a[sortField] > b[sortField]) {
          return -1 * (sortDir === 'asc' ? -1 : 1)
        } else {
          return 0
        }
      })
    }
    setData(newData)
    // xhrRequest(page, sortOrder)
  }
  React.useEffect(() => {
      getUsersListData(1)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const downloadAllUsers = () => {
    SubscriptionServices.exportUsers({
      headers: {
        'Authorization': `Bearer ${keycloak?.token ?? ''}`,
        'Accept': 'application/octet-stream'
      },
      params: filterData(exportFiltersPayload(currentFilter)),
      responseType: 'blob'
    }).then((result) => {
      if (result.data) {
        const type = result.headers['content-type']
        const blob = new Blob([result.data], { type: type, encoding: 'UTF-8' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        const contentDisposition = result.headers['content-disposition']
        let fileName = `${intl.formatMessage({ id: 'Sidebar.Links.Users' })}.xlsx`
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2)
            fileName = fileNameMatch[1]
        }
        link.setAttribute('download', fileName) //or any other extension
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      }
    })
    return false
  }


  const changePage = (page, sortOrder) => {
    xhrRequest(++page, sortOrder)
  }
  const changeFilter = (applyFilters) => {
    setLoadedData([])
    let filterList = applyFilters()
    let filters = {}
    filterList.forEach((filterItem, index) => {
      if (!!filterItem.length) {
        if ('active' === columns[index].name) {
          filters[columns[index].name] = !!filterItem[0] ? 1 : 0
        } else if (filterItem[0].length >= 1) {
          filters[columns[index].name] = filterItem[0]
        }
      }
    })
    setCurrentFilter(filters)
  }

  React.useEffect(() => {
      if (!!currentFilter) {
        xhrRequest(1, {}, true)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentFilter])

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: count,
    search: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [],
    sortOrder: sortOrder,
    confirmFilters: true,
    downloadOptions: { filename: `${intl.formatMessage({ id: 'Sidebar.Links.Users' })}.csv`, separator: ',' },
    customToolbar: () => {
      return (
        <span className={'custom-toolbar-btn'}>
          <Tooltip title={<FormattedMessage id='PaymentRequests.List.Table.Download'/>}>
            <IconButton onClick={downloadAllUsers} className={classes.iconButton}>
              <CloudDownloadIcon/>
            </IconButton>
          </Tooltip>
        </span>
      )
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button color='primary'
                  disabled={!(isFilterValid.username && isFilterValid.email)}
                  variant="contained" onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Users.List.Table.ApplyFilters'/></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip' ||
        (typeof column === 'string' && typeof type === 'string' && type === 'custom'
          && (column === 'username' || column === 'email'))) {
        setLoadedData([])
        let newFilters = () => (filterList)
        console.log('updating filters via chip')
        changeFilter(newFilters)
      }
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'Users.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Users.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Users.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Users.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Users.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Users.List.Table.RowsPerPage' }),
        displayRows: intl.formatMessage({ id: 'Users.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Users.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'Users.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Users.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Users.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Users.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Users.List.Table.All' }),
        title: intl.formatMessage({ id: 'Users.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Users.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Users.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Users.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page, tableState.sortOrder)
          break
        case 'sort':
          sort(tableState.page, tableState.sortOrder)
          break
        default:
          break
      }
    }
  }
  return (
    <>
      <PageTitle title={<FormattedMessage id='Sidebar.Links.Users'/>}
                 button={!!canCreate && <Button
                   classes={{ root: classes.button }}
                   variant="contained"
                   size="large"
                   color="primary"
                   onClick={() => {
                     history.push(NamedRoutes.subscription.user.addAdmin)
                   }}
                 >
                   <FormattedMessage id='Users.List.AddAdmin.Title'/>
                 </Button>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.TableWrapper}>
          {isLoading && <FormLoader loading={true}/>}
          <MUIDataTable
            title={
              <Typography variant="h6">
                <FormattedMessage id='Users.List.Table.Title'/>
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </>
  )
}
